<div [class.default]="!isVersion">
  <ng-container *ngIf="isVersion; else defaultTemplate">
    <span>{{ value }}{{ isNextValueVersion ? '.' : '' }}</span>
  </ng-container>
  <ng-template #defaultTemplate>
    <span>{{ label ? (label | translate) + ':' : '' }} {{ value | decimalPipe }}{{ unit }} </span>
  </ng-template>
</div>
